var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data-table management-main-list-data-table" },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "management-section-wrapper" },
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "management-section-title" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$tc("Template", 2)) + "\n      "
                )
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("v-text-field", {
                staticClass: "data-table-search",
                attrs: {
                  label: _vm.$t("Search"),
                  placeholder: _vm.$t("Search"),
                  value: _vm.searchFromParent,
                  "append-icon": "search",
                  "single-line": ""
                },
                on: { input: _vm.updateSearchInParent }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-data-table", {
            class: { "no-show-permission": !_vm.userHasPermissionTo("show") },
            attrs: {
              headers: _vm.headers,
              items: _vm.templates,
              search: _vm.searchFromParent,
              loading: _vm.loading,
              "loading-text": "",
              "items-per-page-text": _vm.rowsPerPageText,
              "items-per-page-items": _vm.rowsPerPageItems,
              "items-per-page": _vm.paginationReservationTemplate.rowsPerPage,
              "header-props": { sortIcon: _vm.sortIcon },
              "footer-props": {
                prevIcon: _vm.prevIcon,
                nextIcon: _vm.nextIcon,
                "items-per-page-options": _vm.rowsPerPageItems
              }
            },
            on: {
              "update:itemsPerPage": function($event) {
                return _vm.$set(
                  _vm.paginationReservationTemplate,
                  "rowsPerPage",
                  $event
                )
              },
              "update:items-per-page": function($event) {
                return _vm.$set(
                  _vm.paginationReservationTemplate,
                  "rowsPerPage",
                  $event
                )
              },
              pagination: function($event) {
                return _vm.setRowsOnLocalStorage(
                  _vm.dataTableReservationTemplateListId,
                  _vm.paginationReservationTemplate.rowsPerPage
                )
              }
            },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function(props) {
                  return [
                    _c(
                      "tr",
                      {
                        class: {
                          "cursor-pointer": _vm.userHasPermissionTo("show")
                        },
                        on: {
                          click: function($event) {
                            return _vm.viewItem(props.item.art_uuid)
                          }
                        }
                      },
                      [
                        _c("td", [_vm._v(_vm._s(props.item.art_label))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.owner_name))]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getPossibleLayers(props.item)) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.getPossibleStatus(props.item.art_status)
                                  ? _vm.getPossibleStatus(props.item.art_status)
                                  : "-"
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                props.item.art_active
                                  ? _vm.$t("Yes")
                                  : _vm.$t("No")
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.art_index) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _vm.userCanEditOrRemoveItems
                          ? _c(
                              "td",
                              [
                                _c("app-datatable-action-buttons", {
                                  attrs: {
                                    "user-can-edit": _vm.userHasPermissionTo(
                                      "update"
                                    ),
                                    "user-can-delete":
                                      _vm.userHasPermissionTo("destroy") &&
                                      props.item
                                        .active_asset_reservations_count === 0
                                  },
                                  on: {
                                    edit: function($event) {
                                      return _vm.editItem(props.item.art_uuid)
                                    },
                                    delete: function($event) {
                                      return _vm.askConfirmationToDeleteItem(
                                        props.item
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  ]
                }
              },
              {
                key: "pageText",
                fn: function(props) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(props.pageStart) +
                        " - " +
                        _vm._s(props.pageStop) +
                        " " +
                        _vm._s(_vm.$t("tables.Of")) +
                        "\n        " +
                        _vm._s(props.itemsLength) +
                        "\n      "
                    )
                  ]
                }
              },
              {
                key: "no-results",
                fn: function() {
                  return [
                    _c("data-table-no-results", {
                      attrs: { search: _vm.search }
                    })
                  ]
                },
                proxy: true
              },
              {
                key: "no-data",
                fn: function() {
                  return [_vm.loading ? _c("div") : _vm._e()]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("app-dialog-box", {
            attrs: {
              open: _vm.deleteDialog,
              title: _vm.$t("DeleteItem"),
              content:
                _vm.$t("DeleteConfirmation") +
                " " +
                _vm.$tc("Template", 1) +
                " " +
                _vm.itemToDelete.art_label +
                "?",
              "main-action-label": _vm.$t("No"),
              "secondary-action-label": _vm.$t("Yes"),
              loading: _vm.loadingDelete
            },
            on: {
              mainAction: _vm.cancelDelete,
              secondaryAction: _vm.confirmDelete
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fac24d1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fac24d1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssetReservationManagement/Templates/ReservationTemplatesList.vue
// module id = null
// module chunks = 